// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentMethodsSection_container__149yn","paymentMethods":"PaymentMethodsSection_paymentMethods__1FKdY","checkbox":"PaymentMethodsSection_checkbox__EdMfS"};